import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import { LinkWithNativeEvents } from '../link/link';

// header

export const RecallHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px 0 24px;
  margin: 0;
  width: 100%;
  max-width: 1800px;
  background: #ffffff;
  cursor: pointer;

  &:first-child {
    padding-top: 0;
  }
`;

export const RecallHeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1800px;
  background: #ffffff;
  text-align: left;
`;

export const RecallHeaderWarrantiesRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;
export const RecallHeaderRowItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-right: 0;
  margin-bottom: 24px;

  @media (min-width: 769px) {
    margin-right: 48px;
    margin-bottom: 24px;

    flex-direction: row;
    align-items: center;
  }
`;

// content

export const RecallContentContainer = styled.div`
  padding: 0;
`;

export const RecallContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  flex-direction: column;
  padding-bottom: 24px;

  p {
    margin-bottom: 0;
  }

  @media (max-width: 767px) {
    div {
      padding-bottom: 24px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;

    div {
      min-width: 242px;
    }
  }

  @media (min-width: 1024px) {
    div {
      min-width: 314px;
    }
  }
`;
export const RecallContentLeftSideWrapper = styled.span`
  display: flex;
  flex-direction: row;
`;
export const RecallContentRightSideWrapper = styled.span`
  display: flex;
  flex-direction: row;
  width: 100%;

  @media (min-width: 376px) {
    width: auto;
  }
`;
export const RecallContentWarrantiesRow = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  margin: 0 auto 16px auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;
export const RecallContentPowerWarrantiesRow = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  margin: 24px auto 16px auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;
export const RecallContentRowItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  //   margin-right: 48px;
  //   margin-bottom: 24px;
  margin-right: 0;
  margin-bottom: 0;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    margin-right: 0;
    margin-bottom: 0;
  }
`;
export const RecallContentTextWrapper = styled.div`
  margin: 0 0 0 26px;
  max-width: 475px;
  background: #ffffff;
  font-size: 14px;
  line-height: 20px;
`;

// text

export const RecallBoldText = styled.span`
  font-weight: 700;
  color: #183558;
`;
export const RecallText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 0 0 6px;
  line-height: 20px;
  color: #6d7184;

  & ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 4px;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 20px;
  }
`;
export const RecallExpiredText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 0 0 0;
  line-height: 20px;
  color: #6d7184;
`;
export const RecallGreyText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 8px;
  line-height: 20px;
  color: #6d7184;
  background: #f4f8fa;
  border-radius: 3px;
`;
export const RecallGreyList = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 4px 8px;
  color: #6d7184;
  background: #f4f8fa;
  width: auto;

  & ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 16px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
  }
`;
export const RecallLinkText = styled(LinkWithNativeEvents)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

// button

export const RecallContentButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: auto;

  @media (min-width: 769px) {
    margin-top: 0;
    margin-left: 40px;
  }

  @media (max-width: 570px) {
    margin-top: 10px;
    width: 100%;
  }
`;
export const RecallButton = styled(SecondaryButton)`
  display: flex;
  padding: 12px 24px;
  min-width: auto !important;
  min-height: 40px;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  width: 100%;

  @media (min-width: 375px) {
    font-size: 14px;
    min-width: 200px !important;
  }

  @media (min-width: 768px) {
    min-width: 240px !important;
    max-width: 240px;
  }
`;

// miscellaneous

export const RecallIconWrapper = styled.div<{ hasOpenRecalls: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 1800px;
  background: #ffffff;
`;
export const RecallChevronIconWrapper = styled.span<{ isOpen: any }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 6px;
  padding-left: 18px;

  & svg {
    transition: transform 0.5s;
    transform: ${(props) => (props.isOpen === true ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;
export const RecallTitle = styled.div<{ hasOpenRecalls: boolean }>`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  font-feature-settings: 'liga' off;
  color: #183558;
  text-transform: capitalize;
`;

export const RecallRowItemExpiredWarrantyWrapper = styled.span`
  display: block;
`;
export const RecallRowItemWarrantyWrapper = styled.span`
  display: none;

  @media (min-width: 376px) {
    display: block;
  }
`;
export const RecallRowListWarrantyWrapper = styled.span`
  display: block;

  @media (min-width: 376px) {
    display: none;
  }
`;

export const RecallGetThisResolvedWrapper = styled.div`
  background: #f4f8fa;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  span {
    font-size: 16px;
  }

  @media (max-width: 570px) {
    flex-direction: column;

    span {
      font-size: 14px;
    }
  }

  @media (min-width: 768px) {
    padding: 24px;
  }
`;

export const RecallGetThisResolvedText = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: #183558;
`;

export const RecallShowMoreWrapper = styled.div`
  margin: 0 0 24px;
`;

export const RecallShowMoreText = styled.span`
  color: #00aed9;
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
`;

export const ShowMoreContent = styled.div`
  p {
    &:last-child {
      padding: 0;
      margin: 0 0 24px 0;
    }
  }
`;

export const RecallSummaryContainer = styled.div`
  p {
    padding: 0;
    margin: 0;
  }
`;

export const RecallShowMoreContentWrapper = styled.div``;
